/** LookupEnums (LE) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * Name the enum for the LookupGroup's Code. Name the keys to align with the Lookup's Code. The values should align with the Lookup's Murn.
 */
export namespace LE {
  export enum FormName {
    DrainageInjectionWellRenewal = "murn:dws:lookup/FormName/DrainageInjectionWellRenewal",
    ChangeOfOperator = "murn:dws:lookup/FormName/OperatorChange",
  }
  export enum DocumentCategory {
    Facility = "murn:dws:lookup/DocumentCategory/Facility",
    Well = "murn:dws:lookup/DocumentCategory/Well",
  }
  export enum State {
    AK = "murn:dws:lookup/State/AK",
    AL = "murn:dws:lookup/State/AL",
    AR = "murn:dws:lookup/State/AR",
    AS = "murn:dws:lookup/State/AS",
    AZ = "murn:dws:lookup/State/AZ",
    CA = "murn:dws:lookup/State/CA",
    CO = "murn:dws:lookup/State/CO",
    CT = "murn:dws:lookup/State/CT",
    DC = "murn:dws:lookup/State/DC",
    DE = "murn:dws:lookup/State/DE",
    FL = "murn:dws:lookup/State/FL",
    GA = "murn:dws:lookup/State/GA",
    GU = "murn:dws:lookup/State/GU",
    HI = "murn:dws:lookup/State/HI",
    IA = "murn:dws:lookup/State/IA",
    ID = "murn:dws:lookup/State/ID",
    IL = "murn:dws:lookup/State/IL",
    IN = "murn:dws:lookup/State/IN",
    KS = "murn:dws:lookup/State/KS",
    KY = "murn:dws:lookup/State/KY",
    LA = "murn:dws:lookup/State/LA",
    MA = "murn:dws:lookup/State/MA",
    MD = "murn:dws:lookup/State/MD",
    ME = "murn:dws:lookup/State/ME",
    MI = "murn:dws:lookup/State/MI",
    MN = "murn:dws:lookup/State/MN",
    MO = "murn:dws:lookup/State/MO",
    MP = "murn:dws:lookup/State/MP",
    MS = "murn:dws:lookup/State/MS",
    MT = "murn:dws:lookup/State/MT",
    NC = "murn:dws:lookup/State/NC",
    ND = "murn:dws:lookup/State/ND",
    NE = "murn:dws:lookup/State/NE",
    NH = "murn:dws:lookup/State/NH",
    NJ = "murn:dws:lookup/State/NJ",
    NM = "murn:dws:lookup/State/NM",
    NV = "murn:dws:lookup/State/NV",
    NY = "murn:dws:lookup/State/NY",
    OH = "murn:dws:lookup/State/OH",
    OK = "murn:dws:lookup/State/OK",
    OR = "murn:dws:lookup/State/OR",
    PA = "murn:dws:lookup/State/PA",
    PR = "murn:dws:lookup/State/PR",
    RI = "murn:dws:lookup/State/RI",
    SC = "murn:dws:lookup/State/SC",
    SD = "murn:dws:lookup/State/SD",
    TN = "murn:dws:lookup/State/TN",
    TX = "murn:dws:lookup/State/TX",
    UT = "murn:dws:lookup/State/UT",
    VT = "murn:dws:lookup/State/VT",
    VA = "murn:dws:lookup/State/VA",
    VI = "murn:dws:lookup/State/VI",
    WA = "murn:dws:lookup/State/WA",
    WI = "murn:dws:lookup/State/WI",
    WV = "murn:dws:lookup/State/WV",
    WY = "murn:dws:lookup/State/WY",
    AB = "murn:dws:lookup/State/AB",
    BC = "murn:dws:lookup/State/BC",
    MB = "murn:dws:lookup/State/MB",
    NB = "murn:dws:lookup/State/NB",
    NL = "murn:dws:lookup/State/NL",
    NS = "murn:dws:lookup/State/NS",
    ON = "murn:dws:lookup/State/ON",
    PE = "murn:dws:lookup/State/PE",
    QC = "murn:dws:lookup/State/QC",
    SK = "murn:dws:lookup/State/SK",
  }
}
